import { Injectable } from '@angular/core';


@Injectable({ providedIn: 'root' })

export class AssistantService {
    constructor() { }

    requestFilter(request): string {
        let api = '';
        Object.keys(request).forEach((key) => {
            const oldVal = request[key];
            const newVal = oldVal || oldVal === 0 ? (typeof oldVal === 'string' ? oldVal.trim() : oldVal) : null;
            if (newVal || newVal === 0) {
                api += `${key}=${newVal}&`;
            }
        });
        api = api.substr(0, api.length - 1);
        return api;
    }

    notRequestFilter(request): string {
        let api = '';
        Object.keys(request).forEach(key => {
            const oldValue = request[key];
            const newValue = oldValue || oldValue === 0 ? (typeof oldValue === 'string' ? oldValue.trim() : oldValue) : null;
            api += `${key}=${newValue}&`;
        });
        api = api.substr(0, api.length - 1);
        return api;
    }


    resetForm(form) {
      return Object.keys(form.controls).forEach(key => {
            form.get(key).setValue('');
        });
    }
}
